import { useSelector } from 'react-redux';
var usePartialUpload = function () {
    var acceptedFiles = useSelector(function (_a) {
        var additionalInfo = _a.additionalInfo;
        return additionalInfo;
    }).acceptedFiles;
    var submittedFiles = acceptedFiles.filter(function (_a) {
        var alreadySubmitted = _a.alreadySubmitted;
        return alreadySubmitted;
    });
    var notSubmittedFiles = acceptedFiles.filter(function (_a) {
        var alreadySubmitted = _a.alreadySubmitted;
        return !alreadySubmitted;
    });
    var isPartialUpload = submittedFiles.length > 0;
    var hasNewFiles = notSubmittedFiles.length > 0;
    return {
        isPartialUpload: isPartialUpload,
        hasNewFiles: hasNewFiles
    };
};
export default usePartialUpload;
//# sourceMappingURL=usePartialUpload.js.map